import { PropsWithChildren, ReactNode, useState } from 'react';
import * as RadixHoverCard from '@radix-ui/react-hover-card';
import * as styles from './styles';

export function HoverCard({
  trigger,
  children,
  onOpenChange,
}: PropsWithChildren<{
  trigger: ReactNode;
  onOpenChange?: (open: boolean) => void;
}>) {
  const [open, setopen] = useState(false);
  return (
    <RadixHoverCard.Root
      openDelay={0}
      open={open}
      onOpenChange={(o: boolean) => {
        setopen(o);
        onOpenChange(o);
      }}
    >
      <RadixHoverCard.Trigger asChild onClick={() => setopen(true)}>
        {trigger}
      </RadixHoverCard.Trigger>
      <RadixHoverCard.Portal>
        <RadixHoverCard.Content css={styles.styHoverCardContent} sideOffset={5} align="start">
          {children}
        </RadixHoverCard.Content>
      </RadixHoverCard.Portal>
    </RadixHoverCard.Root>
  );
}
